import {
  getAuthorById as getAuthorByIdFromData,
  getDefaultAuthor as getDefaultAuthorFromData,
} from '@/slices/Author/authors/data'

import { Author } from './types'

/**
 * Get author by ID
 */
export const getAuthorById = (id: string): Author | undefined => {
  return getAuthorByIdFromData(id)
}

/**
 * Default author for blog posts
 */
export const getDefaultAuthor = (): Author => {
  return getDefaultAuthorFromData()
}
